import { formatDate, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChange, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../shared/services/apiService.service';
import { FormErrorService } from '../../shared/form-validation/form-error.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { secureStorage } from '../../shared/services/encryption/secureservice';
import { RootService } from '../../shared/services/root.service';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegexService } from '../../shared/form-validation/regex.service';
import { PaymentService } from '../../shared/services/razorpaypayment/payment.service';

@Component({
  selector: 'app-fni-journey',
  templateUrl: './fni-journey.component.html',
  styleUrls: ['./fni-journey.component.scss']
})
export class FniJourneyComponent implements OnInit {
  bookingData:any=[]
  itemsPerPage=10;
  totalItemsBooking:any;
  salesId: string = '';
  dealerCode: any;

  currentPageBooking=1;
  flag: any = 'moreDetails';
  vasDataLocal: any = {};
  userData: any;
  openUrl: boolean;

  orderDetailsIndex: any;
  showBookingList: boolean = true;
  bookdatashow:boolean=false;
  isMobile: boolean = false;
  showRetryPopup: boolean = false;
  VasAmount: any;
  totalAmount: number;
  showPaymentOption: boolean = false;
  showRoomError: boolean = false;
  userAadharno:any;

  amount: any;
  showAmountAlert: boolean = false;
  alertmsg: string;
  showRoomPrice: any = 0;
  showTotalAmount: boolean = false;



  constructor(private apiService:ApiService,private router:Router,private modalService: NgbModal,private fb: FormBuilder,
    private toastrService: ToastrService, @Inject(PLATFORM_ID) private platformId: Object,private localStorage: secureStorage, private secureService: RootService,private formErrorService: FormErrorService, private regexService: RegexService,
    private behaviorService: BehaviourSubjectService,private spinner: NgxSpinnerService,private paymentService: PaymentService) { }

  ngOnInit(): void {
    $('.header').addClass('p-scroll');
    this.dealerCode = localStorage.getItem("dealercd");
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
      this.maximumSize = 6
      // some code..
    } else {
      this.isMobile = false;
      this.maximumSize = 6
    }
    this.userData = this.secureService.getUserData();
    this.getUserdataaddhar();

    this.getOptyData('',0);
    this.userData = this.secureService.getUserData();
  }
  environment1 = environment.s3bucket.url;
  maximumSize: any = 6;
  isSecure: boolean = false;
  bookingDataDeatail: any;
  dealerInfo: any;
  advReceived: boolean = false;
  showTimeLine: boolean = false;
  showEdd: boolean = false;
  ProgressBarData: any = {};
  sub: Subscription = new Subscription
  closeResult: string;
  currentLeadData: any;
  optyData: any;

  @ViewChild("retryPay", { read: TemplateRef }) retryPay!: TemplateRef<any>;
  paymentTypeForm: FormGroup;

  getOptyData(data:any,offset:any){
    let payload = {
      "opty_id": data.trim(),
      "dealer_code": this.dealerCode,
        "offset": offset,
        "limit":10
    }
    this.spinner.show();
    this.sub.add(this.apiService.getFindOpty(payload).subscribe({
      next: (res) => {
        if (res.success) {
          this.bookdatashow=true;
        this.bookingData=res.data;
        this.totalItemsBooking=res?.total_count;
        this.spinner.hide();
        }
        else{
          this.bookdatashow=true;
          this.bookingData=[];
          this.totalItemsBooking=0;
          this.toastrService.warning(res.data.msg);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.bookdatashow=true;
        this.bookingData=[];
        this.totalItemsBooking=0;
        this.spinner.hide();
      },complete: () => { }
    }));
  }

  fnijourneyData: any;
  encryptPanNO: any;
  decryptPanNO: any;
  encryptAdharNo:any;
  decryptAdharNo:any;
  hasTyped:boolean=false
  keyUp(data: any){
    if (this.salesId?.length>0) {
      this.hasTyped=true;
    }
    if (this.hasTyped && this.salesId ==='') {
      this.getOptyData('',0);
      this.hasTyped=false;
    }
  }

  getFniJourney(data:any){
    let payload = {
    "lead_type": "FINANCE",
    "mm_geography": data.MM_GEO_s ? data.MM_GEO_s : '',
    "division_id": data.DIV_ID_s ? data.DIV_ID_s : '',
    "lob": data.LOB_NAME_s ? data.LOB_NAME_s : data.vehicles_info.LOB_NAME_s ,
    "mobile_number": this.userData.mobile_number ? this.userData.mobile_number : '',
    "email_id": this.userData.email_id ? this.userData.email_id : '',
    "first_name": this.userData.first_name ?  this.userData.first_name : '',
    "last_name": this.userData.last_name ? this.userData.last_name : '',
    "address_one": this.userData.address_one ? this.userData.address_one : '',
    "address_two": this.userData.address_two ? this.userData.address_two : '',
    "state": this.userData.state ? this.userData.state : '',
    "state_code": data.PR_CONTACT_STATE_s ? data.PR_CONTACT_STATE_s : '',
    "district": data.PR_CONTACT_DISTRICT_s ? data.PR_CONTACT_DISTRICT_s : '',
    "organization_name": this.userData.organization_name ? this.userData.organization_name : '',
    "vehicle_application":data.vehicle_application ? data.vehicle_application : '',
    "body_type": "NA",
    "usage_category": "",
    "vc_description": data.VC_DESC_TEXT_s ? data.VC_DESC_TEXT_s : '',
    "vc_number": data.VC_NUM_s ? data.VC_NUM_s : '',
    "ppl": data.PPL_NAME_s ? data.PPL_NAME_s : data.vehicles_info.PPL_NAME_s,
    "vc_id": data.VC_ID_s ? data.VC_ID_s : '',
    "pl": data.PL_NAME_s? data.PL_NAME_s : data.vehicles_info.PL_NAME_s ,
    "quantity": data.QTY_s ? data.QTY_s :'',
    "amc": "No",
    "lease_interest": "no",
    "finance_account_id": data.FINANCIER_ID_s ? data.FINANCIER_ID_s : '',
    "finance": data.FINANCIER_NAME_s ? data.FINANCIER_NAME_s : '',
    "model": data.vehicles_info.model ? data.vehicles_info.model : '',
    "is_tml": "True",
    "interested_in_exchange": "No",
    "brand": "",
    "registration_number": "",
    "pi_for_exchange": "",
    "chassis_number": "",
    "manufacture_year": "",
    "mileage": "",
    "action_type": "Billed",
    "channel": data.OPTY_CREATED_THROUGH_s ? data.OPTY_CREATED_THROUGH_s  : '',
    "source": "",
    "medium": "",
    "campaign": "",
    "campaign_id": "",
    "lead_origin": "Booking",
    "ex_showroom_price": 3382695,
    "payment_gateway_type": "CCAVENUE",
    "down_payment": data.vehicles_info.down_payment ? data.vehicles_info.down_payment : '',
    "stock": 0,
    "opty_id": data.ROW_ID ? data.ROW_ID : '',
    "pan_no": this.userData?.user_documents[0]?.doc_number  ? this.userData?.user_documents[0]?.doc_number  : '',
    "aadhar_number": this.userData.user_documents[1].doc_number  ? this.userData.user_documents[1].doc_number : '',
    "row_id": data.X_TM_NEW_CHASSIS_s ?  data.X_TM_NEW_CHASSIS_s :''
    }
    this.sub.add(this.apiService.getFniJourneyCreateLead(payload).subscribe({
      next: (res) => {
        this.fnijourneyData = res.data;
      },
      error : (err) => {
        this.toastrService.warning(err)
      },complete() {

      },
    }));
  }
  preventSpace(event: KeyboardEvent) {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }

  gotoFniform(data:any,intend_app:any,intrested_ex:any,customer_type:any,likely_purchase:any,lead_class:any,usage_category:any,tml_fleet:any,total_fleet:any,lobs:any,vehicles_info:any){
    const vehicles= Object.keys(vehicles_info);
    const quantity = Number(data?.QTY_s);
    const pan = data?.PR_CONTACT_PAN_s
    let checkPan=false
    if (pan) {
      if (pan[3]!=='P' && pan?.length>3) {
        checkPan=true
      }
      else{
        checkPan=false
      }
    }


    if ((quantity == 1) && (!checkPan)) {
      if (vehicles?.length > 0) {
        if (lobs == 'Pickups'|| lobs == 'SCV Cargo' || lobs == 'SCVPass' || lobs == 'PCV - Venture') {
          if (intend_app && intrested_ex && customer_type && likely_purchase && lead_class && usage_category) {
            this.routeTofni(data)
          }
          else{
            this.toastrService.warning("Intended Application,Interested In Exchange,Customer Type,Likely Purchase Month,Lead Classification and Usage Category  are not present")
          }
        }
        else if ((lobs == 'M&HCV Const' || lobs == 'MCV Cargo' || lobs == 'HCV Cargo' || lobs == 'ICV Trucks' || lobs == 'MCV Cargo' || lobs == 'HCV Const' || lobs == 'MCV Trucks') && (customer_type == 'Captive' || customer_type == 'Competition customer' || customer_type == 'ToBeUpdatedByDealership' || customer_type == 'Key Customer' || customer_type == 'Key Account' || customer_type == 'Large Fleet Owner and Retail Customer') && (data.STAGE_NAME_s !=='C2 (Adv. Received)')){
          if (intend_app && intrested_ex && customer_type && likely_purchase && lead_class && tml_fleet && total_fleet) {
            this.routeTofni(data)
          }
          else{
            this.toastrService.warning("Intended Application,Interested In Exchange,Customer Type,Likely Purchase Month,Lead Classification and TML Fleet Size ,Total Fleet Size are not present")
          }
        }
        else{
          if (intend_app && intrested_ex && customer_type && likely_purchase && lead_class) {
            this.routeTofni(data)
          }
          else{
            this.toastrService.warning("Intended Application,Interested In Exchange,Customer Type,Likely Purchase Month,Lead Classification   are not present")
          }
        }
      }
      else{
        this.toastrService.warning("Vehicle details are not available with fleetverse ecosystem .")
      }
    }
    else
    {
      this.toastrService.warning("The financing option is currently available only for individual customers with single vehicle quantity.")
    }
    }
  redirect(data) {
    let lob = data?.vehicles_info?.lob?.replace(/\s/g, "-")?.toLowerCase() === 'icv-trucks'
      ? 'trucks'
      : (data?.vehicles_info?.lob?.replace(/\s/g, "-")?.toLowerCase() === 'buses'
        ? 'buses-vans'
        : data?.vehicles_info?.lob?.replace(/\s/g, "-")?.toLowerCase());
    let model = data?.vehicles_info?.model?.replace(/\s/g, '-')
                             .replace(/\//g, '-')
                             .replace(/\+/g, '-')
                             .replace(/\./g, '-')
                             ?.toLowerCase();
    var currentUrl = `/product-details/${lob}/${data?.vehicles_info?.ppl}/${data?.vehicles_info?.pl}/${model}/${data?.vehicles_info?.product_id}`;
    return currentUrl;
  }

  copyMessage(val) {
    navigator.clipboard.writeText(val)
  }
  getTotalAmount(leads) {
    let finalAmt = leads?.payment_info?.length > 0 ? leads?.payment_info?.amount : leads?.vehicles_info?.down_payment * leads?.INIT_QUANTITY_s
    let mainTotalAmount;
    // if (leads.vas_data?.length > 0) {
    //   let VasAmount = Number(leads.vas_data[0].vas_payble_amount);
    //   mainTotalAmount = finalAmt + VasAmount;
    // } else {
      mainTotalAmount = finalAmt
    // }
    return mainTotalAmount;
  }
  moreDetails(row_id: any, index: any, flag) {

    this.flag = flag;
    if (this.orderDetailsIndex == index) {
      if (this.isSecure && flag == 'moreDetails') {
        this.showBookingList = false;
      } else if (!this.isSecure && flag == 'secure') {
        this.showBookingList = false;
      }
      else {
        this.orderDetailsIndex = null;
        this.showBookingList = true;
      }

      this.isSecure = flag != 'moreDetails' ? true : false
    } else {
      this.orderDetailsIndex = index;
      this.showBookingList = false;
      this.isSecure = flag != 'moreDetails' ? true : false
      this.bookingData.filter((x: any) => {
        if (x.row_id == row_id) {
          this.bookingDataDeatail = x;
          this.dealerInfo = this.bookingDataDeatail.dealer_info;
        }
      });
    }
  }
  getVehicle(item) {
    this.advReceived = false;
    this.showTimeLine = false;
    this.showEdd = false;
    this.ProgressBarData = []; this.ProgressBarData = [];
    if ((item.lead_channel == 'OSP_Configurator' || item.lead_channel == 'Fleet Verse Configurator') && item.opty_status == 'C2 (Adv. Received)') {
      this.showTimeLine = true;
      let data = {
        opty_id: item.opty_id,
      }
      this.sub.add(this.apiService.getVehicleData(data).subscribe({
        next: (res: any) => {
          this.showEdd = true;
          this.ProgressBarData = res?.vehicle_edd_details;
        }
      }))
    }
  }
  makeFNIPayment(lead) {
    if (lead?.vas_data?.length > 0) {

      this.vasDataLocal['AnnualKms'] = lead.vas_data[0].avg_monthly_km;
      this.vasDataLocal['Exshowroomprice'] = lead.ex_showroom_price ? Math.round(lead.ex_showroom_price) : lead.product.price_range;
      this.vasDataLocal['LOB'] = lead.product.sub_lob;
      this.vasDataLocal['NoOfyears'] = lead.product.sub_lob;
      this.vasDataLocal['SubLob'] = lead.product.lob;
      this.vasDataLocal['VASBookingAmount'] = lead.vas_data[0].vas_payble_amount;
      this.vasDataLocal['VASPLAN'] = lead.vas_data[0].vas_category;
      this.vasDataLocal['VASTotalAmount'] = lead.product.sub_lob;
      this.vasDataLocal['VCNUMBER'] = lead.vas_data[0].vehicle_number;
      this.vasDataLocal['VasAvailable'] = 'YES';
      this.vasDataLocal['fuel_type'] = lead.vas_data[0].fuel_type;
      this.vasDataLocal['isViaConfigurator'] = true;
      this.vasDataLocal['terrian'] = lead.vas_data[0].terrian;
      this.vasDataLocal['vasApplication'] = lead.vas_data[0].application;
      this.vasDataLocal['id'] = lead.vas_data[0].id;

      this.localStorage.setItem(
        'VASDataProfile',
        JSON.stringify(this.vasDataLocal)
      );
    }

    if (isPlatformBrowser(this.platformId)) {
      let sublob = lead.product.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (lead.product.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : lead.product.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = lead.product.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.localStorage.setItem('retryPaymentData', JSON.stringify(lead))
      this.router.navigate(['/lead-booking/' + sublob + '/' + lead.product.lob_seo + '/' + lead.product.ppl_seo + '/' + model + '/' + lead.product.id + '/Finance']);

    }

  }
  async generateChallengeToken(leadData: any) {
    if (leadData?.ROW_ID && leadData?.X_SRC_FINANCE_s) {
      let data = {
        "appName": "com.tatamotors.cv_online_portal",
        "crmOpportunityID": leadData?.ROW_ID
      }

      this.sub.add(this.apiService.getfniToken(data).subscribe({
        next: (data: any) => {

          if (data?.challengeToken) {
            this.localStorage.setItem('productVehicleImgUrl', JSON.stringify(leadData?.vehicles_info?.image[0]?.image_url ? leadData.vehicles_info.image[0].image_url : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/placeholder.webp'));
            this.onTrackButtonClick(leadData.ROW_ID, this.userData.mobile_number, data?.challengeToken);
          }
          else {
            this.toastrService.warning(data?.message);
          }

        }
      }))
    }

    else {
      var element = document.getElementById('fetch_btn')
      element.click();

    }
  }
  Payment(leads,opty_id) {

    if (isPlatformBrowser(this.platformId)) {

      try {
        this.spinner.show();
        this.sub.add(this.apiService.getLeads({
          "offset": 0,
          "limit": 10,
          "lead_channel": "",
          "opty_id": opty_id
      }).subscribe({
          next: (response: any) => {
            if (response.success) {
              // this.bookingData = response.data.leads;
              this.optyData = response?.data;
              this.showRetryPopup = false;
    if ((response?.data?.leads[0]?.payment_status == 'aborted' || response?.data?.leads[0]?.payment_status == 'Payment Failed'
      || response?.data?.leads[0]?.payment_status == 'PENDING' || response?.data?.leads[0]?.payment_status == 'UNBILLED') &&
      (response?.data?.leads[0]?.opty_status == 'C1 (Quote Tendered)' || response?.data?.leads[0]?.opty_status == 'C1A (Papers submitted)'
        || response?.data?.leads[0]?.opty_status == 'PENDING')
    ) {
      this.leadData(response?.data.leads[0])
    }
    else {
      this.refreshPaymemt(response?.data.leads[0]);
    }
              this.spinner.hide();
            }
            else {

              this.spinner.hide();
              this.toastrService.warning(response.data.msg)
            }
          },
          error: () => {
            this.toastrService.warning("Something went wrong!")
            this.spinner.hide();
          },
          complete: () => {
            this.spinner.hide();
          }
        }))
      } catch (error) {
        this.spinner.hide();
      }
    }

  }
  refreshPaymemt(leads) {
    if (leads.payment_info?.razorpay_order_id) {
      this.showRetryPopup = false;

      let request = { "id": leads.payment_info?.razorpay_order_id };

      this.sub.add(this.apiService.getrefreshPayment(request).subscribe({
        next: (data: any) => {

          if (data.data.payment_status == 'aborted') {
            this.currentLeadData = leads;


            this.paymentTypeForm = this.fb.group({
              paymentType: [leads?.razor_pay_detail?.length > 0 ? (leads?.razor_pay_detail[0].payment_gt_type)?.toLowerCase() : 'razorpay'],
              amount: [leads?.payment_info?.length > 0 ? (leads?.payment_info?.amount / leads?.quantity) :
                (leads?.product?.down_payment)]
            });
            if (leads?.razor_pay_detail?.length > 1) {
              const data = this.paymentTypeForm.get("paymentType");
              data.setValidators([Validators.required]);
              data.updateValueAndValidity();
            }
            if (leads?.payment_status == 'initialized') {
              // this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });
              this.getOptyData('',0);
            }
          }
          else {
            // this.getBookingDetails({ "offset": 0, "limit": 10, "lead_channel": '' });
            this.getOptyData('',0);
            this.toastrService.warning("Payment is under process please wait for some time.")

          }
          if (isPlatformBrowser(this.platformId)) {
            window.scroll(0, 0)
          }
        },
        error: () => {
          this.toastrService.warning("Something went wrong!")
        },
        complete: () => {
        }
      })
      );
    } else {
      // this.toastrService.warning("Payment is under process please wait for some time.")
      this.showRetryPopup = false;
      this.leadData(leads)

      this.currentLeadData = leads;
      this.paymentTypeForm = this.fb.group({
        paymentType: [leads?.razor_pay_detail?.length > 0 ? (leads?.razor_pay_detail[0].payment_gt_type)?.toLowerCase() : 'razorpay'],
        amount: [leads?.payment_info?.length > 0 ? (leads?.payment_info?.amount / leads?.quantity) :
          (leads?.product?.down_payment)]
      });
      if (leads?.razor_pay_detail?.length > 1) {
        const data = this.paymentTypeForm.get("paymentType");
        data.setValidators([Validators.required]);
        data.updateValueAndValidity();
      }
    }
  }
  openPopup2(openForm: any) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'side-drawer'
    };
    this.modalService.open(openForm, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  leadData(leads: any) {
    this.currentLeadData = leads;
    if (leads?.payment_status == 'UNBILLED' && leads?.razor_pay_detail?.length == 0) {
      this.toastrService.warning('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
      return;
    }
    else if (leads?.razor_pay_detail?.length == 0) {
      this.toastrService.warning('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
      return;
    }
    else {
      this.openPopup2(this.retryPay);
      this.paymentTypeForm = this.fb.group({
        paymentType: [leads?.razor_pay_detail?.length > 0 ? (leads?.razor_pay_detail[0].payment_gt_type)?.toLowerCase() : 'razorpay'],
        amount: [leads?.payment_info?.length > 0 ? (leads?.payment_info?.amount / leads?.quantity) :
          (leads?.product?.down_payment)]
      });
      let finalAmt = leads?.payment_info?.length > 0 ? leads?.payment_info?.amount : leads?.product?.down_payment * leads?.quantity

      if (leads.vas_data?.length > 0) {
        this.VasAmount = Number(leads.vas_data[0].vas_payble_amount);
      } else {
        this.VasAmount = 0;
        this.totalAmount = finalAmt
      }
      this.showRetryPopup = true;
      this.openPopup2(this.retryPay);
      if (leads?.razor_pay_detail?.length > 1) {
        if (leads.vas_data?.length > 0) {
          this.showPaymentOption = false;

          leads?.razor_pay_detail.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              this.totalAmount = finalAmt + this.VasAmount;
              this.paymentTypeForm.controls['paymentType'].setValue('ccavenue');
              this.paymentTypeForm.get("paymentType").updateValueAndValidity();
              return;
            }
          });
        } else {

          this.totalAmount = finalAmt + this.VasAmount;
          this.paymentTypeForm.controls['paymentType'].setValidators([Validators.required])
          this.paymentTypeForm.updateValueAndValidity();
          this.showPaymentOption = true;
        }
      } else {
        if (leads.vas_data?.length > 0 && leads?.razor_pay_detail?.length == 1) {
          leads.razor_pay_detail.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              this.totalAmount = finalAmt
              this.showPaymentOption = false;
              this.paymentTypeForm.controls['paymentType'].setValue('razorpay');
              this.paymentTypeForm.get("paymentType").updateValueAndValidity();
              return;
            } else {
              this.showPaymentOption = false;
              this.totalAmount = finalAmt + this.VasAmount;
              this.paymentTypeForm.controls['paymentType'].setValue('ccavenue');
              this.paymentTypeForm.get("paymentType").updateValueAndValidity();
              return;
            }
          });
        } else if (leads?.razor_pay_detail?.length == 0) {

          this.totalAmount = finalAmt + this.VasAmount;
          this.toastrService.error('We are unable to find payment gateway account. Please contact TML on Toll Free Number 1800 209 7979 or cac@tatamotors.com for assistance.');
          return;
        }
      }
    }
  }
  onTrackButtonClick(optyID: any, mobileNumber: any, challengeToken: any) {
    this.openUrl = true;
    this.router.navigate(['/fni/application-overview'],
      { queryParams: { login_id: mobileNumber, opty_id: optyID, token: challengeToken } }
    );
  }
  numSequence(n: number): Array<number> {
    return Array(n);
  }
  getLeadCss(leads?, codition?): String {
    // this.activeClass = false;
    var temp = ''
    if (codition == 'C2 (Adv. Received)') {
      this.advReceived = true;
    }
    leads?.filter((x: any) => {
      if (x.opty_status == codition) {
        // this.activeClass = true;
        temp = 'active';
      }
    });
    return temp;
  }
  getLeadStatus(leads?, codition?): String {
    var temp = ''
    leads?.filter((x: any) => {
      if (x.opty_status == codition) {
        temp = formatDate(
          x.updated_date, "dd-MM-yyyy", "en-US");

      }

    });
    return temp;

  }

  pageChangeBooking(page : any){
    this.currentPageBooking = page;
    page = page - 1;
    this.getOptyData(this.salesId,page);
    this.scrollToTop();
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  submitPaymentMode(leadsData) {
    this.amount = this.paymentTypeForm.value.amount;
    if (this.paymentTypeForm.status == 'INVALID') {
      this.formErrorService.displayFormErrors(this.paymentTypeForm);
      return;
    }
    var payamount = leadsData?.product?.down_payment;
    if (this.amount < payamount) {
      this.showAmountAlert = true;
      this.alertmsg =
        "Down payment should be greater than ₹" +
        this.numberWithCommas(payamount);
      return;
    }
    this.showRoomPrice = leadsData?.ex_showroom_price ? Math.round(leadsData?.ex_showroom_price)
      : leadsData?.product?.price_range ? leadsData?.product?.price_range : 0;
    if (this.showRoomPrice !== 0 && (this.totalAmount > (this.showRoomPrice * leadsData?.quantity))) {
      this.showRoomError = true;
      this.showTotalAmount = true;
      return;
    }
    if (this.showRoomPrice !== 0 && (this.totalAmount > 500000)) {
      return;
    }
    //  }

//  let encryptAdhar=this.localStorage.encryptData(this.userAadharno[0]?.doc_number)
 let encryptAdhar=this.userAadharno[0]?.doc_number;

    if (leadsData.razor_pay_detail?.length == 1) {
      // this.openSelectPaymentModal.hide();
      let payment_type = leadsData.razor_pay_detail[0].payment_gt_type == "CCAVENUE" ? 'ccavenue' : 'razorpay';
      this.paymentService.makePayment(leadsData, this.optyData, true, 'booking', null, payment_type, this.amount,encryptAdhar);
    }
    else {
      let payament_type = this.paymentTypeForm.controls['paymentType'].value;
      if (payament_type) {
        if (leadsData.razor_pay_detail.findIndex(val => val.payment_gt_type?.toLowerCase() == payament_type) > -1) {
          // this.openSelectPaymentModal.hide();
          this.paymentService.makePayment(leadsData, this.optyData, true, 'booking', null, payament_type, this.amount,encryptAdhar);
        }
        else {
          this.toastrService.error("Please select valid payment")
        }
      }

    }
    //       // }
  }
public hasRequiredError = (controlName: string): boolean | undefined =>
  this.formErrorService.hasRequiredError(controlName, this.paymentTypeForm);
onlyNumberKey(event: any) {
  return this.regexService.NumberKeyEvent(event);
}
notAllowSpace(event: any) {
  if (event.target.selectionStart === 0 && event.which === 32) {
    event.preventDefault();
  }
}
getUserdataaddhar(){
  this.sub.add(this.apiService.getUserData().subscribe({
    next: (response: any) => {
    this.userAadharno=response?.data?.user_documents.filter((res)=>{
      return  res.document_description == 'aadhar_card'
      })
    }
  }));
}
numberWithCommas(x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}
close() {

  this.modalService.dismissAll();
}
getBookingAmount(leadData) {
  this.totalAmount = this.paymentTypeForm.value.amount * leadData.quantity
}
routeTofni(data:any){
  const div_id = data.DIV_ID_s;
  const optyId = data.ROW_ID;
  const status = data.STAGE_NAME_s;
  const ass_login = data?.ASSIGN_LOGIN_s;
  const channel_type = data?.CHANNEL_TYPE_CD_s;
  const created_through = data?.OPTY_CREATED_THROUGH_s;
  const first_name = data.PR_CONTACT_FST_NAME_s;
  const last_name = data.PR_CONTACT_LAST_NAME_s;
  const mobile_number = data.PR_CONTACT_CELL_PH_NUM_s;
  const contact_id = data.PR_CON_ID_s;
  let lob = data?.vehicle_info?.lob?.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.vehicle_info?.lob?.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data?.vehicles_info?.lob?.replace(/\s/g, "-")?.toLowerCase();
  let model = data?.vehicles_info?.model?.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
  let routePath = `/lead-booking/${lob}/${data?.vehicles_info?.ppl}/${data?.vehicles_info?.pl}/${model}/${data?.vehicles_info?.product_id}/FinanceJourneyNonOsp`;
  let queryParams: any = {};

// if (div_id) {
// queryParams.div_id = div_id;
// }
if (optyId) {
queryParams.optyId = optyId;
}
// if (status) {
// queryParams.status = status;
// }
// if (ass_login) {
// queryParams.ass_login = ass_login;
// }
// if (channel_type) {
// queryParams.channel_type = channel_type;
// }
// if (created_through) {
// queryParams.created_through = created_through;
// }
// if (first_name) {
// queryParams.first_name = first_name;
// }
// if (last_name) {
// queryParams.last_name = last_name;
// }
// if (mobile_number) {
// queryParams.mobile_number = mobile_number;
// }
// if (contact_id) {
// queryParams.contact_id = contact_id;
// }

this.router.navigate([routePath], { queryParams });
}
  ngOnDestroy(): void {
    this.bookdatashow=false;
  }
}
